import { z } from 'zod';
import i18n from 'i18next'; // Import i18next

export const signUpSchema = z.object({
  phoneNumber: z
    .string()
    .regex(/^05\d{8}$/, i18n.t('login.schema.phoneNumberPattern'))
    .transform((value) => `966${value.slice(1)}`),
  password: z.string().min(8, i18n.t('login.schema.passwordMinLength')),
  confirmPass: z.string().min(8, i18n.t('login.schema.passwordMinLength')),
})
.refine((data) => data.password === data.confirmPass, {
  path: ['confirmPass'],
  message: i18n.t('login.schema.passwordsDontMatch'),
});

export const loginSchema = z.object({
  phoneNumber: z
    .string()
    .regex(/^05\d{8}$/, i18n.t('login.schema.phoneNumberPattern'))
    .transform((value) => `966${value.slice(1)}`),
  password: z.string().min(8, i18n.t('login.schema.passwordMinLength')),
});

export const forgetPassSchema = z.object({
  phoneNumber: z
    .string()
    .min(10, i18n.t('login.schema.phoneNumberInvalid'))
    .max(10, i18n.t('login.schema.phoneNumberExact'))
    .regex(/^0[5-9][0-9]{8}$/, i18n.t('login.schema.phoneNumberPattern'))
    .transform((value) => `966${value.slice(1)}`),
});
